import StackTags from './StackTags';

export default StackTags;
